<h2>This product is Lottery-only! 🎉</h2>
<p style="text-align: center">If you win the lottery, the payment will be automatically applied to your payment method.</p>
<p style="text-align: center"><strong>We invite you to read the rules and important points completely.</strong></p>

<ul style="padding-left: 20px; list-style-type: none">
  <li style="margin-bottom: 10px">
    <strong>🔹 Price dollar</strong> - Approximately {{ item.price_currency[0].regular_price / 18.78 | currency: " US " : "symbol-narrow" : "1.0-0" }} (The charge will be made for {{ item.price_currency[0].regular_price | currency }}
    MXN )
  </li>
  <li style="margin-bottom: 10px"><strong>🔹 Limited quantity</strong> – Only a {{ item.stock }} units are available.</li>
  <li style="margin-bottom: 10px"><strong>🔹 Shipping cost</strong> – Shipping costs will be charged once we calculate the shipping address you provide. The cost is not included in the product.</li>
  <li style="margin-bottom: 10px"><strong>🔸 Final sale</strong> – No refunds, returns, or exchanges once the order is processed.</li>
  <li style="margin-bottom: 10px"><strong>🔸 Shipping responsibility</strong> – We are not responsible for damages, losses, or delays caused by the courier service.</li>
  <li style="margin-bottom: 10px"><strong>⚠️ When registering, keep in mind that you are obligated to pay if you win. Failure to do so will result in your being banned from future lotteries or site sales, as applicable.</strong></li>
</ul>
<p>Good luck! 🍀 If you win, your product will arrive soon!</p>

@if (!(item.date_lottery[1] | dateEndLottery)) {
  The lottery has closed registration, good luck to all participants.
} @else if ((item.date_lottery | dateLottery) || notify === true) {
  <!-- <app-form-payment-stripe [amount]="amountTotal" [user]="dataUser?.destination" [rate]="dataRate"
  [listNameProduct]="listNameProduct" [listproduct]="listproduct"
  (paymentMethod)="createPaymentIntent($event, amountTotal)"
  [successPaymentMessage]="successPaymentMessage"></app-form-payment-stripe> -->
  <app-stripe-setup-intents [item]="item" />
} @else {
  The lottery has not started yet and will return on this date <strong>{{ item.date_lottery[0] | date }}</strong
  >.
  <p class="text-center countDown">
    <countdown #cd [config]="config" (event)="handleEvent($event)" />
    <br />
    Do not reload the page when the counter ends
  </p>
}
